import { getSessionItem, removeSessionItem, setSessionItem } from "@/utils/safeStorage";

const INTEGRATION_RETURN_PATH_KEY = "integration-return-path";

function normalizeIntegrationReturnPath(path: string | null | undefined): string | null {
  if (!path) return null;
  if (!path.startsWith("/") || path.startsWith("//")) return null;
  return path;
}

export function setPendingIntegrationReturnPath(path: string) {
  const normalized = normalizeIntegrationReturnPath(path);
  if (!normalized) return false;
  return setSessionItem(INTEGRATION_RETURN_PATH_KEY, normalized);
}

export function getPendingIntegrationReturnPath() {
  return normalizeIntegrationReturnPath(getSessionItem(INTEGRATION_RETURN_PATH_KEY));
}

export function clearPendingIntegrationReturnPath() {
  return removeSessionItem(INTEGRATION_RETURN_PATH_KEY);
}
